<template>
  <el-dialog
      title="凭证信息"
      :visible.sync="showModal"
      :close-on-click-modal="false"
      :destroy-on-close="true"
  >
    <el-row type="flex" justify="space-between">
      <el-col v-if="detailData == 'upload'">
        <div class="box">
          <h3>上传凭证</h3>
          <div>
            <uploadList
                v-model="imgArray"
                width="200px"
                height="200px"
            ></uploadList>
          </div>
        </div>
      </el-col>
      <el-col v-if="detailData == 'view'">
        <el-row :gutter="10" class="mb-20">
          <el-col :span="6" v-for="(item, index) in detail.proofs" :key="index">
            <el-image :preview-src-list="detail.proofs" :src="item"></el-image>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="options-box">
      <el-row type="flex" justify="space-between">
        <el-button @click="trunOff">返回</el-button>
        <div v-if="detailData == 'upload'">
          <!-- <el-button type="warning" @click="rejectModalVisible = true"
            >驳回</el-button
          > -->
          <el-button type="primary" @click="handlePass('通过')">通过</el-button>
        </div>
      </el-row>
    </div>

    <el-dialog
        title="驳回"
        :visible.sync="rejectModalVisible"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        append-to-body
        width="512px"
    >
      <el-form
          ref="rejectForm"
          :model="rejectForm"
          :rules="rejectRules"
          label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
              type="textarea"
              placeholder="驳回理由"
              :rows="4"
              v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm('rejectForm')"
          >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>

<script>
import request from '@/utils/request'
import uploadList from '@/components/UploadList/index.vue'
export default {
  data: () => ({
    dialogImageUrl: '',
    dialogVisible: false,
    imgArray: [],
    rejectRules: {
      reason: [{ required: true, message: '请填写驳回理由', trigger: 'blur' }],
    },
    rejectForm: {
      reason: '',
    },
    rejectModalVisible: false,
  }),
  components: {
    uploadList,
  },
  props: {
    // 展示
    show: {
      default: false,
      type: Boolean,
    },
    detail: {
      default: {},
      type: Object,
    },
    detailData: null,
  },
  methods: {
    trunOff() {
      this.showModal = false
    },
    handlePass(text) {
      console.log(this.detail)
      if (!this.imgArray.length > 0) {
        return this.$message({
          type: 'info',
          message: '请上传凭证',
        })
      }
      request({
        url: '/api/backend/userCashOut/uploadProofs',
        method: 'post',
        data: {
          id: this.detail.id,
          proofs: this.imgArray,
        },
      })
          .then((response) => {
            this.btnLoading = false
            this.dialogFormVisible = false
            this.$message({
              title: '成功',
              message: '保存成功',
              type: 'success',
              duration: 2000,
            })
            this.showModal = false
            this.$emit('onUpdate')
          })
          .catch((err) => {
            this.btnLoading = false
          })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
  },
  computed: {
    showModal: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
  },
  watch: {
    show(v) {
      if (v) {
        this.rejectForm.reason = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.info-box {
  margin-top: -14px;
}
.id_img {
  width: 300px;
  height: 150px;
  img {
    width: 100%;
    height: 100%;
  }
}
.box {
  padding-bottom: 40px;
  color: #333;
}
.nowrap {
  white-space: nowrap;
  margin-right: 40px;
}
.text1 {
  margin: 10px 0;
}
.text-606266 {
  color: #606266;
}
</style>
